import React from 'react';
import {Link, Stack, Switch, Tooltip, Typography} from '@mui/material';
import SourceScore from '../SourceScore';
import {getClassificationByValue} from '../../features/products/reportEditorPage/components/addNewSource/constants';
import {CLASSIFICATION_COLORS} from '../../theme/classificationColors';

const DEFAULT_CLASSIFICATION = {
    label: 'U - Unclassified',
    bgColor: CLASSIFICATION_COLORS.U.bg,
};

/**
 * Document metadata bar with score, classification, source info, and view mode toggle
 */
const DocumentMetadata = React.memo(({
                                         score,
                                         onScoreChange,
                                         classificationLevel,
                                         docUrl,
                                         docSource,
                                         sourceScore,
                                         docSourceType,
                                         hasHTML,
                                         viewMode,
                                         onViewModeChange,
                                         loadingHtml
                                     }) => {
    const classLevel = getClassificationByValue(classificationLevel) || DEFAULT_CLASSIFICATION;

    return (
        <Stack direction={'row'} alignItems={'center'} gap={1} flexWrap={'wrap'}

               sx={{
                   transition: 'all 0.15s ease-in-out'
               }}
        >
            <Tooltip title={'Document Reliability'} placement={'top'} arrow>
                <SourceScore value={score} onChange={onScoreChange}/>
            </Tooltip>

            <Tooltip title={'Document Classification Level'} placement={'top'} arrow>
                <Typography
                    variant={'body2'}
                    color={'text.primary'}
                    px={1}
                    bgcolor={classLevel.bgColor}
                >{classLevel.label}</Typography>
            </Tooltip>

            <Typography variant={'body2'} color={'text.secondary'}>|</Typography>

            <Stack
                direction={'row'} alignItems={'center'}
                px={1} spacing={1} bgcolor={'#eeeeee'} borderRadius={1}
            >
                <Tooltip title={'Document Source'} placement={'top'} arrow>
                    <Link
                        variant={'body2'}
                        href={docUrl}
                        target={'_blank'}
                        rel={'noopener noreferrer'}
                    >{docSource ? docSource : 'domain.com'}</Link>
                </Tooltip>

                <Tooltip title={'Source Reliability Score'} placement={'top'} arrow>
                    <Typography variant={'body2'} color={'text.primary'}>
                        {(sourceScore !== null && Number.isFinite(sourceScore))
                            ? Math.round(sourceScore * 100) + '%'
                            : 'Undefined'}
                    </Typography>
                </Tooltip>
            </Stack>

            <Tooltip title={'Document Source Type'} placement={'top'} arrow>
                <Typography
                    variant={'body2'}
                    color={'text.primary'}
                    px={1}
                    bgcolor={classLevel.bgColor}
                >{docSourceType ? docSourceType : 'OSINT'}</Typography>
            </Tooltip>

            {hasHTML && (
                <>
                    <Typography variant={'body2'} color={'text.secondary'}>|</Typography>

                    <Stack direction={'row'} spacing={1} alignItems="center" flexShrink={0}>
                        <Switch
                            size="small"
                            checked={viewMode === 'text'}
                            onChange={onViewModeChange}
                            disabled={loadingHtml}
                        />
                        <Typography variant={'body2'} color={'text.secondary'}>
                            {loadingHtml ? 'Loading HTML...' : 'Plain Text'}
                        </Typography>
                    </Stack>
                </>
            )}
        </Stack>
    );
});

export default DocumentMetadata;
